const axios = require('axios').default;

export const addPurchaseOrderItemList = (props = {token:"", rnOrderId:0, purchaseOrderItems:[], receiptOrderItems:[]}) => {
    return axios.post(`${process.env.REACT_APP_API_URL}/api/addPurchaseOrderItemList/`,{
        rnOrderId:props.rnOrderId,
        rnData:JSON.stringify(props.receiptOrderItems),
        data:JSON.stringify(props.purchaseOrderItems)
    },{
        headers: {
            Authorization: 'Basic ' + props.token
        }
    });
}

export const insertItemListInfo = (props = {token:"", insertItemListInfo:[]}) => {
    return axios.post(`${process.env.REACT_APP_API_URL}/api/insertItemListInfo/`,{
        data:JSON.stringify(props.insertItemListInfo)
    },{
        headers: {
            Authorization: 'Basic ' + props.token
        }
    });
}

export const setPurchaseOrderItemListWeigh = (props = {token:"", data:[]}) => {
    return axios.post(`${process.env.REACT_APP_API_URL}/api/setPurchaseOrderItemListWeigh/`,{
        data:props.data
    },{
        headers: {
            Authorization: 'Basic ' + props.token
        }
    });
}

export const setPurchaseOrderItemList = (props = {token:"", rnOrderId:0, items:[], itemsUI:[]}) => {
    return axios.post(`${process.env.REACT_APP_API_URL}/api/setPurchaseOrderItemList/`,{
        rnOrderId:props.rnOrderId,
        items:props.items,
        itemsUI:props.itemsUI
    },{
        headers: {
            Authorization: 'Basic ' + props.token
        }
    });
}

export const setItemListInfo = (props = {token:"", data:[]}) => {
    return axios.post(`${process.env.REACT_APP_API_URL}/api/setItemListInfo/`,{
        data:props.data
    },{
        headers: {
            Authorization: 'Basic ' + props.token
        }
    });
}

export const setPurchaseOrderStorageDate = (props = {token:"", date:"", poId:0}) => {
    return axios.post(`${process.env.REACT_APP_API_URL}/api/setPurchaseOrderStorageDate/`,{
        date:props.date,
        poId:props.poId
    },{
        headers: {
            Authorization: 'Basic ' + props.token
        }
    });
}

export const setPOState = (props = {token:"", state:2, poId:0}) => {
    return axios.post(`${process.env.REACT_APP_API_URL}/api/setPOState/`,{
        poId:props.poId,
        state:props.state
    },{
        headers: {
            Authorization: 'Basic ' + props.token
        }
    });
}

export const getPOLogs = (props = {token:"", logType:'po', poId:0}) => {
    return axios.get(`${process.env.REACT_APP_API_URL_PO_LOGGING_GET}`, 
    {   
        params:{ 
            logType:props.logType,
            id:props.poId
        },
        headers: {
          'Authorization': `Basic ${props.token}`,
        }
    });
}

export const postPO = (props = {token:"", poId:0, cusPORef:""}) => {
    return axios.post(`${process.env.REACT_APP_API_URL}/api/purchaseOrder`,{
        data: {
            poId:props.poId,
            cusPORef:props.cusPORef
        }
    },{
        headers: {
            Authorization: 'Basic ' + props.token
        }
    });
}

export const getPurchaseOrdersItemsByPOId = (props = {token:"", poId:0}) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/getPurchaseOrdersItemsByPOId`, 
    {   
        params:{ 
            id:props.poId
        },
        headers: {
          'Authorization': `Basic ${props.token}`,
        }
    });
}

export const getPurchaseOrdersItemsQty = (props = {token:"", supplierId:0, from:null, to:null}) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/getPurchaseOrdersItemsQty`, 
    {   
        params:{ 
            supplierId:props.supplierId,
            from:props.from,
            to:props.to
        },
        headers: {
          'Authorization': `Basic ${props.token}`,
        }
    });
}


export const getPOHistoryListRestuarant = (props = {token:"", state:[], businessId:0, supplierId:0, specialStartTime:"", specialEndTime:"", searchDateType:"delivery", searchDate:"1900-00-00"}) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/getPOHistoryList/restuarant`, 
    {   
        params:{ 
            state:props.state,
            businessID:props.businessId,
            supplierID:props.supplierId,
            specialStartTime:props.specialStartTime,
            specialEndTime:props.specialEndTime,
            searchDate:props.searchDate,
            searchDateType:props.searchDateType
        },
        headers: {
          'Authorization': `Basic ${props.token}`,
        }
    });
}

export const putPurchaseOrderRemark = (props = {token:"", data:{}}) => {
    return axios.put(`${process.env.REACT_APP_API_URL}/api/putPurchaseOrderRemark/`,{
        data:props.data
    },{
        headers: {
            Authorization: 'Basic ' + props.token
        }
    });
}

export const getPODetails = (props = {token:"", id:0}) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/getPODetails/${props.id}`, {
        headers: {
          Authorization: "Basic " + props.token,
        },
      })
}

export const getItemListInfo = (props = {token:"", id:0}) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/getItemListInfo/`, {
        headers: {
          Authorization: "Basic " + props.token,
        },
        params: {
          id: props.id,
        }
    })
}